import { extend } from 'vee-validate';

extend('katakana', {
  validate: (value) => {
    return {
      required: true,
      // Katakana full width
      // https://viblo.asia/p/mot-so-loai-regex-cho-tieng-nhat-thuong-su-dung-LzD5dxwz5jY
      // Example:
      //   1. ヨーロッパ
      //   2. レディ
      valid: /^([ァ-ン]|ー)+\s{0,}$/.test(value),
    };
  },
  computesRequired: true,
});
